import { Sparkles } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SectionTag } from "../components/SectionLabel";

const ITEMS = [
  "Atendimento direto com as sócias",
  "Atuação artesanal, feita para o caso concreto",
  "Transparência do início ao fim",
  "Resposta rápida",
  "Foco na melhor solução possível",
];

export const Differentiators = () => (
  <section className="bg-teal-dark py-24 lg:py-32" data-testid="differentiators-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <SectionTag icon={Sparkles} label="Diferenciais" tone="light" />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-cream max-w-xl mb-14">
          O que muda quando o caso é levado a sério.
        </h2>
      </Reveal>

      <div className="divide-y divide-cream/15">
        {ITEMS.map((item, i) => (
          <Reveal key={item} delay={0.15 + i * 0.06}>
            <div
              className="flex items-baseline gap-6 py-6 group"
              data-testid={`differentiator-item-${i}`}
            >
              <span className="font-mono text-sm text-cream/40 w-8">{String(i + 1).padStart(2, "0")}</span>
              <span className="font-serif text-xl sm:text-2xl text-cream group-hover:translate-x-2 transition-transform duration-300 inline-block">
                {item}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
